module.exports = "nb-card-body {\n  padding-bottom: 80px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/field-edit/field-edit.component.scss
// module id = ./src/app/components/field-edit/field-edit.component.scss
// module chunks = main